import React, { useEffect, useState } from "react";
import { allpermissions } from "../funtionsBD/Mainservice";
import { useTranslation } from "react-i18next";

export function PermissionsList() {
  const [data, setdata] = useState();
  const { t } = useTranslation();

  const usersStyle = {
    padding: "15px 20px",
  };

  useEffect(() => {
    getpermission();
  }, []);

  const getpermission = async () => {
    try {
      const response = await allpermissions();
      setdata(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={usersStyle}>
      <div className="data_table_over">
        <table className="data_table">
          <thead>
            <tr>
              <th>{t("id")}</th>
              <th>{t("permission")}</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((role, index) => (
              <>
                <tr key={index}>
                  <td>{role.per_id}</td>
                  <td>{role.name}</td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
